import * as Yup from 'yup'
import { REGEX_TEXTAREA } from '@/constants/regex'
import i18n from 'i18n'

import { BrandsOptions } from '@/state/brands/models'
import { getValidatePassword } from '@/utils'
/**
 * ======================================
 * F O R M   V A L U E S
 * ======================================
 */

export type FormValuesDetails = {
  firstname: string
  lastname: string
  username: string
  email: string
  brands: BrandsOptions[]
  resetPassword: boolean
  password: string
  confirmPassword: string
}

export type FormValuesTwoFactor = {
  twoFactorCode: string
}

/**
 * ======================================
 * I N I T I A L   V A L U E S
 * ======================================
 */

export const initialValuesDetails: FormValuesDetails = {
  firstname: '',
  lastname: '',
  username: '',
  email: '',
  brands: [],
  resetPassword: false,
  password: '',
  confirmPassword: '',
}

export const initialValuesTwoFactor: FormValuesTwoFactor = {
  twoFactorCode: '',
}

/**
 * ======================================
 * V A L I D A T I O N S   S C H E M A S
 * ======================================
 */

const requiredString = Yup.string().required(i18n.t('error.requiredField'))

export const validationSchemaDetails = Yup.object().shape({
  firstname: requiredString
    .max(100, ({ max }) =>
      i18n.t('messages.inputMaxLength', {
        field: i18n.t('labels.name'),
        max,
      }),
    )
    .matches(REGEX_TEXTAREA, i18n.t('error.regexTextarea')),
  lastname: requiredString
    .max(255, ({ max }) =>
      i18n.t('messages.inputMaxLength', {
        field: i18n.t('labels.description'),
        max,
      }),
    )
    .matches(REGEX_TEXTAREA, i18n.t('error.regexTextarea')),
  brands: Yup.array().min(1, i18n.t('error.requiredField')),
  password: Yup.string().when('resetPassword', {
    is: true,
    then: getValidatePassword(true),
  }),
  confirmPassword: Yup.string().when('resetPassword', {
    is: true,
    then: getValidatePassword(true).oneOf(
      [Yup.ref('password'), null],
      i18n.t('error.passwordDontMatch'),
    ),
  }),
})
